import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const trainingClass = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Name or title of the training class.'),

    startDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('When the training class begins.'),

    endDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('When the training class ends.'),

    venueId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to Venue'),

    instructorId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to User'),

    venue: references('Venue', 'venueId'),

    instructor: references('User', 'instructorId'),

    classEnrollments: hasMany('ClassEnrollment', 'trainingClassId'),
  })
  .describe(
    'A scheduled training session for candidates, held at a venue with an instructor.',
  )
  .as('TrainingClass');

export { trainingClass as trainingClassSchema };
